import { defineStore } from "pinia";

interface AuthModalStore {
  isOpen: boolean;
}

export const useAuthModal = defineStore("authModal", {
  state: (): AuthModalStore => ({
    isOpen: false,
  }),
  actions: {
    onOpen() {
      this.isOpen = true;
    },
    onClose() {
      this.isOpen = false;
    },
  },
});
